import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, locationDetailFeatureKey } from './location-detail.reducer';

export const locationDetailFeature = createFeatureSelector<State>(locationDetailFeatureKey);

export const getLocation = createSelector(locationDetailFeature, (state) => {
   return state.location;
});

export const getLocationCallState = createSelector(locationDetailFeature, (state) => {
   return state.callState;
});
